import { createContext, useContext } from 'react';
import { noop } from 'utils/noop';
import type { TemplateHistoryTemplate, TemplateHistoryMetadata } from '../types';

export type TemplateHistoryContextState = {
  isLoading: boolean;
  metadata?: TemplateHistoryMetadata[];
  refetch: () => void;
  template?: TemplateHistoryTemplate;
  templateContentIds?: number[];
  templateId?: string;
};

export const defaultHistoryContextState: TemplateHistoryContextState = {
  isLoading: false,
  metadata: undefined,
  refetch: noop,
  template: undefined,
  templateContentIds: undefined,
  templateId: undefined,
};

export const TemplateHistoryContext = createContext<TemplateHistoryContextState>(
  defaultHistoryContextState,
);

export const useTemplateHistoryContext = () => useContext(TemplateHistoryContext);
